import React, { useContext, useEffect, useState } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../store';

import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { SkinsTableRow } from './Components/SkinsTableRow';
import { useEventLeaderboardsState } from '../Context/EventLeaderboards.context';

interface IProps {
  roundId?: number;
}

export const SkinsTable = (props: IProps) => {
  const { roundId } = props;

  const {
    actions: {
      holeResults: { get: getHoleResults }
    },
    holeResults
  } = useContext(GlobalContext);

  const { selectedFlightId } = useEventLeaderboardsState();

  const { results, selectedRoundFormat, selectedScoreType, skinsResults } = useAssignResultsState();

  const {
    actions: { setSkinsResults },
    dispatch: dispatchAssignResults
  } = useAssignResultsDispatch();

  useEffect(() => {
    getHoleResults(roundId);
  }, []);

  useEffect(() => {
    dispatchAssignResults({ type: 'sortResults' });
  }, [results]);

  useEffect(() => {
    if (roundId && selectedRoundFormat && selectedScoreType) {
      setSkinsResults(
        holeResults,
        roundId,
        selectedScoreType,
        selectedRoundFormat.considerFlights,
        selectedFlightId
      );
    }
  }, [holeResults, selectedScoreType, selectedRoundFormat, selectedFlightId]);

  const [collapsedRow, setCollapsedRow] = useState<number>();

  const onClick = (index: number) => () =>
    setCollapsedRow(collapsedRow === index ? undefined : index);

  return (
    <div className="event-leaderboards-table horseRaceTable">
      <Table className="leaderboard-score-table">
        <colgroup>
          {[0, 1, 2, 3].map(index => (
            <col key={index} />
          ))}
        </colgroup>
        <TableHead className="leaderboard__thead">
          <TableRow className="leaderboard-header">
            <TableCell className="leaderboard-header__cell override index">Hole</TableCell>
            <TableCell className="leaderboard-header__cell override playerName">Player</TableCell>
            <TableCell className="leaderboard-header__cell override result">Score</TableCell>
            <TableCell className="leaderboard-header__cell override result" />
          </TableRow>
        </TableHead>
        <TableBody className="leaderboard__tbody">
          {skinsResults && Object.keys(skinsResults).length > 0 ? (
            Object.keys(skinsResults).map((hole: string, index: number) => (
              <SkinsTableRow
                key={`row-skins-${hole}-${index}`}
                hole={hole}
                index={index}
                onClick={onClick}
                collapsedRow={collapsedRow}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} className="no-results">
                No results to show
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
